<template>
  <div>
    <el-dialog
            :visible.sync="dialogVisible"
            class="fu-xing-purchase-dialog"
            width="960px">
      <div class="clearfix">
        <div class="clearfix">
          <div class="pull-left left bg-white">
            <p class="title">复星系好产品</p>
            <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/fu_xing_purchase_dialog_pro.jpg" alt="">
          </div>
          <div class="pull-left fxg-pro bg-white">
            <p>2020年初始，复星集团董事长郭广昌说：复星要与其生态合作伙伴之间建立多层次、多维度、多角度的全方位合作模式。</p>
            <p>一链网作为复星全球生态供应链的智能平台，将逐步建设夯实合作伙伴的互惠生态平台。</p>
            <p>当下，一链联合复星系各成员企业推出“福星购”商城，让复星系的供应链合作伙伴、员工及家庭均能与复星的成员企业、员工享受同优同质同惠的好产品。</p>
            <p>2020年必定是不平凡的一年，复星将与全球合作伙伴们众志成城、共同抗疫。</p>
            <p style="margin-bottom: 0;">优惠仅限复星合作伙伴们，详情欢迎拨打一链客服热线：</p>
            <p class="phone">0516-87796393</p>
          </div>
        </div>

        <div>
          <div class="fxg-qrcode pull-left">
            <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/7EAF2E4E-4D97-4918-A1E4-F6B497B56473.png" alt="">
          </div>
          <div class="fxg-qrcode-desc">
            <p style="margin-bottom: 12px;">微信扫二维码，加福星购客服获取邀请码</p>
            <p>(第一次登录注册需要邀请码，务必联系我们的客服人员获取相关邀请码哦)</p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        dialogVisible: false
      }
    }
  }
</script>
<style lang="stylus">
  .fu-xing-purchase-dialog{
    .el-dialog{
      height: 518px;
      background: url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/fu_xing_purchase_dialog_bg.png") no-repeat;
      background-size: cover;
      p{
        margin-bottom: 0;
      }
      .el-dialog__body{
        padding: 0;
        color: #909399 ;
      }
      .el-dialog__headerbtn{
        padding-top: 30px;
        top: -20px;
        right: 14px;
      }
      .left{
        width: 516px;
        height: 334px;
        box-sizing: border-box;
        padding: 6px 0 0 24px;
        margin-left: 36px;
        .title{
          font-size: 18px;
          color: #3F88E0;
          padding: 8px 0;
        }
      }
      .phone{
        padding-top: 2px;
        font-size: 18px;
        color: #CF2727;
        font-weight: 500;
        display: inline-block;
        vertical-align: middle;
      }
      .fxg-qrcode{
        margin-left: 36px;
        width:96px;
        height: 96px;
        img{
          display: block;
          width: 100%;
        }
      }
      .fxg-qrcode-desc{
        margin-left:146px;
        margin-top: 24px;
        padding-top: 16px;
        font-size: 14px;
        color: #303133;
      }
      .fxg-pro{
        width: 372px;
        height: 334px;
        font-size: 12px;
        padding: 22px 24px 24px;
        line-height: 24px;
        p{
          margin-bottom: 6px;
        }
      }
    }
    .bg-white{
      background-color: #fff
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/fuXingPurchaseDialog/index.vue